import React from "react";
import { string } from "prop-types";
import "./class.scss";

const Class = ({
  day,
  venue,
  street,
  town,
  postcode,
  mapUrl,
  lesson1,
  lesson2,
  lesson3,
  price,
  info
}) => {
  return (
    <div className="class-item">
      <h3>{day}</h3>
      <h4>{venue}</h4>
      <address>
        {street}, {town}
        <br />
        {postcode}
      </address>
      <p>
        <a target="_blank" rel="noopener noreferrer" href={mapUrl}>
          Get Directions
        </a>
      </p>
      <p>
        {lesson1}
        {lesson2 && (
          <>
            <br />
            {lesson2}
          </>
        )}
        {lesson3 && (
          <>
            <br />
            {lesson3}
          </>
        )}
      </p>
      <p>{price}</p>
      <p>
        <em>{info}</em>
      </p>
    </div>
  );
};

Class.propTypes = {
  day: string.isRequired,
  venue: string.isRequired,
  street: string.isRequired,
  town: string.isRequired,
  postcode: string.isRequired,
  mapUrl: string.isRequired,
  lesson1: string.isRequired,
  lesson2: string,
  lesson3: string,
  price: string.isRequired,
  info: string
};

Class.defaultProps = {
  lesson2: "",
  lesson3: "",
  info: ""
};

export default Class;
